import { useLocale } from '../context/DynamicLocaleProvider';
import { GlobalMicroButton } from './GlobalMicroButton';
import { PerfinaEmptyStateGraphic } from './PerfinaEmptyStateGraphic';
import styles from './GlobalEmptyState.module.css';

interface GlobalEmptyStateProps {
  buttonText?: string;
  onButtonClick?: () => void;
  buttonIcon?: React.ReactNode;
}

export default function GlobalEmptyState({ buttonText, onButtonClick, buttonIcon }: GlobalEmptyStateProps) {
  const { t } = useLocale();

  return (
    <div className={styles.emptyState}>
      <PerfinaEmptyStateGraphic />
      <h4 className={styles.title}>{t('global_empty_state_title')}</h4>
      <p className={styles.description}>{t('global_empty_state_description')}</p>
      {buttonText && onButtonClick && (
        <GlobalMicroButton
          onClick={onButtonClick}
          icon={buttonIcon}
        >
          {buttonText}
        </GlobalMicroButton>
      )}
    </div>
  );
}
